<template>
    <div class="market">
        <div id="tab-bar">
            <div class="tab-bar-item" v-for="(n,i) in marketCartName" :key="i">
                <span v-bind:class="{ selectedFontColor: selectedItemIndex==i }" @click="clickCate(i)">{{$t(n)}}</span>
                <div v-bind:class="{ selectedBgColor: selectedItemIndex==i }"></div>
            </div>
        </div>
        <div v-if="!goods_lists" class="noPage">
            <img src="../../assets/images/no_page.png" alt=""  width="160">

        </div>
       <!-- <div class="ticket-cate-panel">
            <span v-for="(cateItem,i) in this.goods_list" :key="i" @click="selectCateGoodsFunc(i)" :class="{ pitchOnCateGoods:i == selectedSmallItemIndex }">{{cateItem.group_name}}</span>
        </div> -->
        <div class="goodsPanel" v-for="(item,index) in goods_lists" :key="index">
            <div class="goodsPanelTitle"><span>{{item.group_name}}</span></div>
            <ticket v-for="(item2,k) in item.info" :key="k" :goods_item="item2"></ticket>
        </div>

    </div>
</template>

<script>
import ticket from "../../components/markets/ticket";
export default {
  name: "market",
  components: {
    ticket
  },
  data: function() {
    return {
      marketCartName: [
        "online_type[0]",
        "online_type[1]",
        "online_type[2]",
        "online_type[3]"
      ],
      selectedItemIndex: 0,
      currentCateGoodsList: "",
      selectedSmallItemIndex: 0,
      routeDex: "",
      goods_lists: []
    };
  },
  inject: ["showMsg"],
  methods: {
    // 解析url中的参数
    getGoodsCatId: function() {
      let goodsIndex = this.$route.query.dex;

      if (!goodsIndex) {
        this.getGoodsListFunc(854);
      } else {
        this.clickCate(goodsIndex);
      }
    },
    // 点击tab-bar中不同的分类所触发的方法
    clickCate: function(i) {
      this.$store.commit("set_goods_list", "");
      this.selectedItemIndex = i;
      this.$router.push({ path: `/market/?dex=${i}` });

      let catId; //商品分类的id
      if (i == 0) {
        //门票
        catId = 854; //854
      } else if (i == 1) {
        //酒店
        catId = 859; //859
      } else if (i == 2) {
        //年卡
        catId = 848; //848
      } else if (i == 3) {
        //餐饮
        catId = 860; //860
      }

      this.selectedSmallItemIndex = 0;
      this.getGoodsListFunc(catId);
    },
    // 发送请求获取数据
    getGoodsListFunc: function(catId) {
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + this.hurl + "/Goods/reservesList",
        dataType: "json",
        data: {
          id: catId //票务商品分类的id
        }
      })
        .then(res => {
          if (res.data.status === 1) {
              this.goods_lists = res.data.result;
           /* if (this.$i18n.locale !== "zh") {
              switch (catId) {
                case 854:
                  this.goods_lists = this.$t("market_1");
                  break;
                case 859:
                  this.goods_lists = this.$t("market_2");
                  break;
                case 848:
                  this.goods_lists = this.$t("market_3");
                  break;
                case 860:
                  this.goods_lists = this.$t("market_4");
                  break;
              }
            } else {
              this.goods_lists = res.data.result;
            }*/
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    },
    selectCateGoodsFunc: function(i) {
      this.currentCateGoodsList = this.goods_list[i].info;
      this.selectedSmallItemIndex = i;
    }
  },
  created: function() {
    // console.log(this.$route.query.dex);
    this.getGoodsCatId();
    this.$store.commit("set_current", 6);
    this.$store.commit("set_title", "nav.online");
  },
  mounted: function() {
    // console.log(this.goods_list);
  },
  computed: {
    weburl: function() {
      return this.$store.state.weburl;
    },
    hurl: function() {
      return this.$store.state.hurl;
    },
    goods_list: function() {
      return this.$store.state.market.goods_list;
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/common.less";
.market {
  background: @bg;
  padding-bottom: 10px;
}
#tab-bar {
  width: @width;
  height: 50px;
  background-color: @font-primary;
  overflow: auto;
  white-space: nowrap;
  margin-bottom: 20px;
  // position: fixed;
}
#tab-bar::-webkit-scrollbar {
  display: none;
}
.tab-bar-item {
  display: inline-block;
  height: 50px;
  line-height: 40px;
  /*width: 85px;*/
  padding: 0 8px;
  text-align: center;
}
.tab-bar-item div {
  width: 30px;
  height: 4px;
  margin: 0 auto;
  position: relative;
  bottom: 5px;
  .border-radius(3px);
}
.tab-bar-item span {
  color: @word;
}
.selectedFontColor {
  color: @brick_red !important;
}
.selectedBgColor {
  background-color: @brick_red;
}
.ticket-item-cate {
  margin-top: 10px;
}
.ticket-cate-panel {
  // position: fixed;
  // top: 150px;
  padding-left: 12px;
  padding-right: 12px;
  // background-color: #fff;
}
.ticket-cate-panel span {
  display: inline-block;
  height: 1.8rem;
  line-height: 1.8rem;
  padding-left: 4px;
  padding-right: 4px;
  border: 1px solid #742528;
  border-radius: 20px;
  margin-bottom: 7px;
  margin-right: 6px;
  color: #742528;
}
.pitchOnCateGoods {
  background-color: #742528;
  color: white !important;
}
.goodsPanel {
  width: 94%;
  // height: 50vh;
  background-color: #f1e2d8;
  margin: 0 auto 15px;
  border-radius: 10px;
  padding-top: 7px;
  padding-bottom: 8px;
}
.goodsPanelTitle {
  width: 94%;
  height: 8vh;
  line-height: 8vh;
  text-align: center;
  margin: 0 auto 7px;
  background-image: url("../../assets/images/goodsTitle.png");
  background-size: 100% 100%;
}
.goodsPanelTitle span {
  font-size: 1.2rem;
  letter-spacing: 1px;
  font-weight: 550;
  color: #78262d;
}
.noPage {
  width: 100%;
  text-align: center;
  margin: 150px auto 200px;
}
@media (min-width: 768px) {
  .market {
    min-height: 650px;
  }

  .goodsPanelTitle span {
    font-size: 1.5rem;
  }
}
</style>
